window.addEventListener("load", function () {
    function toggleSubscriptionOptions() {
        const subscriptionRadio = document.getElementById("subscription-radio");
        const subscriptionOptions = document.getElementById("subscription-options");

        if (subscriptionRadio && subscriptionOptions) {
            displayType = subscriptionRadio.checked ? "flex" : "none";
            subscriptionOptions.style.display = displayType;
        }
    }

    // Delegación de eventos: escuchar en el contenedor principal
    document.body.addEventListener("click", function (event) {
        if (event.target && event.target.matches("#subscription-radio")) {
            toggleSubscriptionOptions(); // Cambiar opciones cuando se selecciona el radio
        }

        // Verificar si se hace clic en un radio de tipo de compra
        if (event.target && event.target.matches("input[name='purchase_type']")) {
            toggleSubscriptionOptions(); // Actualizar suscripción si cambia el tipo de compra
        }
    });

    // Asegurarse de que las opciones estén ocultas al inicio
    const subscriptionOptions = document.getElementById("subscription-options");
    if (subscriptionOptions) {
        subscriptionOptions.style.display = "none"; // Ocultar opciones de frecuencia por defecto
    }
});
